/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />

namespace TabAurous.Sales {

    import fld = MaterialOutItemsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class MaterialEditorForJobWork extends _Ext.GridEditorBase<MaterialOutItemsRow> {


        protected getColumnsKey() { return "Sales.MaterialForJobWork"; }
        protected getDialogType() { return MaterialOutItemsDialog; }
        protected getLocalTextPrefix() { return MaterialOutItemsRow.localTextPrefix; }
        protected form: MaterialOutItemsForm;

        private pendingChanges: Q.Dictionary<any> = {};

        // #region Variables
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public LaborMarkup: number;
        public ExchangeRate: number;
        public DeptId: number;
        private NewLineNo: number;
        private GenSKU = true;
        private contractTotals: string;
        public TotalItems: number;
        public ProductTypeId: number;
        public isUpdate: boolean;
        statement: string;
        //static LineNo: number;
        static Items: JobWork.JobWorkItemsRow;
        public closed: boolean;

        public LineNo: number;
        public BagNo: string;
        public karatid: number;
        public producttypeid: number;
        public metalcolorid: number;
        // #endregion


        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ forceFitColumns: true });
        }



        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();

            var num = ctx => ColumnFormatter.numericInputFormatter(ctx, this);
            var int = ctx => ColumnFormatter.integerInputFormatter(ctx, this);
            var str = ctx => ColumnFormatter.stringInputFormatter(ctx, this);

            //var Department = Q.first(columns, x => x.field === fld.DepartmentId);
            //Department.referencedFields = [fld.DepartmentId];
            //Department.format = ctx => ColumnFormatter.selectFormatter(ctx, fld.DepartmentId, OMS.DepartmentMasterRow.getLookup());

            if (this.GenSKU == false) {
                Q.first(columns, x => x.field === fld.Pieces).format = int;
            }

            let itemtype = Q.first(columns, x => x.field === fld.Pieces);

            itemtype.format = ctx => {
                if (ctx.item.ItemTypeId == 105)
                    return ColumnFormatter.integerInputFormatter(ctx, this);
            }

            ///Q.first(columns, x => x.field === fld.Pieces).format = int;
            Q.first(columns, x => x.field === fld.Weight).format = num;


            //To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            return columns;
        }

        // #endregion

        public getTotalRows(Item: any) {
            this.TotalItems = this.view.getItems().length;
            return this.TotalItems;
        }
        //#region  ItemGrid Inline Editor
        // **** Delete event handler ****
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);


            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();


                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }
            if (target.hasClass('edit numeric')) {
                e.preventDefault();

                if (target.hasClass('edit numeric')) {
                    // var x = Q.coalesce(Q.trimToNull(input.val()), '0');
                    //TODO: Need to add System Parameter to enable disable blocking
                    var input = $(e.target);
                    if (input != undefined) {
                        let values;

                        var input = $(e.target);
                        var y = input.data();
                        if (y.field == "Weight" && item.ItemTypeId == 101) {
                            target.addClass('readonly');
                            target.blur();
                        }
                        else if (y.field == "Pieces" && item.ItemTypeId == 104) {
                            target.addClass('readonly');
                            target.blur();
                        }

                    }

                    this.view.refresh();
                }
            }
        }

        public setData(Items: any[]) {
            //set data in Material Grid from Job Work
            //this.Items = Items;
            let BOMdetails;
            for (let item of Items) {
                BOMdetails = item.BOMDetails;
                for (var BOM of BOMdetails) {
                    var exists: boolean = false;
                    var PrdDetails: OMS.ProductMasterRow;
                    OMS.ProductMasterService.Retrieve({ EntityId: BOM.BOMProductId }, response => PrdDetails = response.Entity, { async: false });

                    if (PrdDetails.ItemTypeId != 104) {
                        var detail: Sales.MaterialOutItemsRow = {
                            AttributeId: BOM.BOMAttributeId,
                            ProductCode: BOM.ProductCode,
                            ProductId: BOM.BOMProductId,
                            DepartmentId: item.DepartmentId,
                            ProductName: BOM.ProductName,
                            SKU: item.SKU,
                            Line_No: item.Line_No,
                            Pieces: BOM.Pieces == null ? 0 : BOM.Pieces,
                            Weight: BOM.Weight,
                            HSN: item.HSN,
                            Attribute: PrdDetails.Attribute,
                            CalcOnId: BOM.CalcOnId,
                            Purity: PrdDetails.Purity
                        };
                        //  JobWork.JobWorkDialog.editorClosed = true;
                        var x = this.view.getItems();
                        x.forEach(function (value) {

                            if (value.Line_No == detail.Line_No && value.ProductId == BOM.BOMProductId)
                                exists = true;
                        });
                        if (exists == false) {
                            detail[this.getIdProperty()] = "`" + this.nextId++;
                            this.view.addItem(detail);
                        }
                        else {
                            Q.notifyWarning("RM Already Issued!!");
                        }

                    }

                }
            }
        }

        public setBOMData(Items: any[], item: any) {
            //set data in Material Grid from Job Work
            //this.Items = Items;
            for (var BOM of Items) {
                var exists: boolean = false;
                var PrdDetails: OMS.ProductMasterRow;
                OMS.ProductMasterService.Retrieve({ EntityId: BOM.BOMProductId }, response => PrdDetails = response.Entity, { async: false })

                var DeptName = OMS.DepartmentMasterRow.getLookup().itemById[item.DepartmentId].DeptName
                if (PrdDetails.ItemTypeId != 104) {
                    var detail: Sales.MaterialOutItemsRow = {
                        AttributeId: BOM.AttributeId,
                        ProductCode: PrdDetails.ProductCode,
                        ProductId: BOM.ProductId,
                        DepartmentId: item.DepartmentId,
                        DeptName: DeptName ,
                        ProductName: PrdDetails.ProductName,
                        SKU: item.SKU,
                        Line_No: item.Line_No,
                        Pieces: BOM.Pieces == null ? 0 : BOM.Pieces,
                        Weight: BOM.Weight,
                        HSN: item.HSN,
                        Attribute: PrdDetails.Attribute,
                        CalcOnId: BOM.CalcOnId,
                        Purity: PrdDetails.Purity == undefined ? 0 : PrdDetails.Purity
                    };

                    if (exists == false) {
                        detail[this.getIdProperty()] = "`" + this.nextId++;
                        this.view.addItem(detail);
                    }
                    else {
                        Q.notifyWarning("RM Already Issued!!");
                    }
                }


            }
            this.closed = true;
        }

        //#region Inline Editor
        //Row Edit Event handler
        private inputsChange(e: JQueryEventObject, ) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value;

            // *** Validate Decimal & Integer***
            if (field === fld.Pieces || field === fld.Discount) {
                value = Q.parseInteger(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            } else if (field === fld.Weight || field === fld.Discount) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else if (input.hasClass('numeric')) {
                var i = Q.parseInteger(text);
                if (isNaN(i) || i > 32767 || i < 0) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
                value = i;
            }
            else {
                value = text;
            }
            var stockdata: Stock.StockItemRow[];
            Stock.StockItemService.CustomMaterialOutList({
                ProductIds: [item.ProductId]
            }, function (response) {
                return stockdata = response.Entities;
            }, { async: false });
            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Pieces && value > 0) {

                if (item.CalcOnId == 3) {
                    if (stockdata.length > 0 && stockdata[0].Pieces >= value) {
                        item.GrossAmount = item.UnitRate * value;
                        item.NetAmount = item.UnitRate * value;

                        item[field] = value;

                        this.view.updateItem(id, item);
                        this.view.refresh();
                    } else {
                        Q.notifyError('Invalid Quantity', '', null);
                        input.val(oldText);
                        input.focus();
                        return;
                    }
                }
                else {
                    if (stockdata.length > 0 && stockdata[0].Pieces >= value) {
                        //item.GrossAmount = item.UnitRate * value;
                        //item.NetAmount = item.UnitRate * value;

                        item[field] = value;

                        this.view.updateItem(id, item);
                        this.view.refresh();
                    } else {
                        Q.notifyError('Invalid Quantity', '', null);
                        input.val(oldText);
                        input.focus();
                        return;
                    }
                }
            }
            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Weight && value > 0) {

                if (item.CalcOnId == 4 || item.CalcOnId == 5) {
                    if (stockdata.length > 0 && stockdata[0].Weight >= value) {
                        item.GrossAmount = item.UnitRate * value;
                        item.NetAmount = item.UnitRate * value;
                        item.NetWeight = value;
                        item[field] = value;
                        this.view.updateItem(id, item);
                        this.view.refresh();
                    }
                } else {
                    Q.notifyError('Invalid Quantity', '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }

            }
            // *** Calculate Wastage ***
            if (field === fld.WstPer && value >= 0) {
                item.WstWt = item.NetWeight * (value / 100);
                item[field] = value;
            }

            // *** Calculate Discount ***
            if (field === fld.Discount && value >= 0) {
                item.GrossAmount = item.NetAmount - value;
                item[field] = value;

            }

            // *** Set Department ***
            if (field === fld.DepartmentId && value > 0) {
                item[field] = value;

            }

            this.view.updateItem(id, item);
            this.view.refresh();

            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }


        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }


        // #endregion


        // #region Buttons Add-Remove
        protected getButtons() {
            let buttons = super.getButtons();
            var grid = Stock.StockForMaterialSelectGrid;
        /*    buttons.pop();
            // *** Add Select Button to Grid Editor ***
            buttons.push({
                title: "Select Materials",
                cssClass: "add-button",
                hotkey: "Alt+K",
                onClick: () => {
                    if (this.isUpdate) {
                        Q.notifyWarning("Cannot Add Materials while Editing");
                        return;

                    }

                    // **** Validate Party before Item Selection ****
                    if (MaterialEditorForJobWork.Items == null) {
                        Q.notifyWarning("Please Select Products to proceed");
                        return;

                    }
                    else {
                        let productIds = [];

                        let details = MaterialEditorForJobWork.Items.BOMDetails;
                        for (let bom of details) {
                            let exists = false;
                            for (let old of productIds) {
                                if (old == bom.BOMProductId) {
                                    exists = true;
                                }
                            } if (!exists) {
                                productIds.push(bom.BOMProductId);
                            }
                        }

                        var filters: _Ext.SelectGridFilters = {
                            ProductIds: productIds,

                        }

                        Stock.StockForMaterialSelectGrid.ItemType = 3;
                        Stock.StockForMaterialSelectGrid.productIds = productIds;
                        var pickerDialog = new _Ext.GridItemPickerDialog({
                            gridType: grid, multiple: true, title: "Select Items",
                            preSelectedKeys: this.value.map(k => k.ProductId)
                        });
                    }

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        //alert('Length' + selectedItems.length);
                        var self = this;
                        var details = []; 
                        var genSKU = this.GenSKU;
                        var rateListId = this.RateListId; 
                        var newLineNo = this.NewLineNo;
                        var deptId = this.DeptId;
                        var companyId = Q.Authorization.userDefinition.CompanyId;

                        // #region Items to Grid
                        //for (let value of selectedItems2)
                        selectedItems2.forEach(function (value) {
                            var PrdId = value.ProductId;
                            var bomdetails = [];
                            let PrdDetails: OMS.ProductMasterRow;
                           
                            // #endregion

                            // #region Rate, Tax , SKU & Labor 
                            var Rate = 0;
                            var LaborRate = 0;

                            // **** Get SKU for Item ****
                            if (genSKU == true) {
                                var SKU = FormatHelper.GetFormat("Sku", "HO");
                            }

                            // #endregion

                            // #region ProductBOM

                            // **** Get and Set Product BOM ****
                            value.BOMDetails.forEach(function (value) {
                                //Get Product Details
                                let BOMPrdDetails;
                                OMS.ProductMasterService.Retrieve({
                                    EntityId: value.BOMProductId
                                }, response => {
                                    BOMPrdDetails = response.Entity
                                }, { async: false });
                                var PrdCode = BOMPrdDetails.ProductCode;
                                var BomAtbId = BOMPrdDetails.AttributeId;

                                //Get ProductBOM Attributes
                                var BOMPrdATB = value;
                                if (value.ItemType == "METAL") {
                                    var karat = BOMPrdATB.KaratId;
                                    var MetalColor = BOMPrdATB.MetalColorId;
                                    var StdPurity = BOMPrdDetails.Purity;
                                    var ItemTypeId = BOMPrdATB.ItemTypeId;
                                    var BOMRate = GetItemRateHelper.GetGetMetalRate(BOMPrdATB.SubCategoryId);


                                    // *** Rate Calculation ***
                                    //Get Rate from Pricelist or Standard Rate to Calculate BOM Amount and add it to Item Rate
                                    var Amount = value.CalculateOn == 3 ? value.Pieces * BOMRate : value.Weight * StdPurity * BOMRate;
                                    Rate += Amount;
                                    // *** End Rate Calculation ***

                                    var MaterialOutBOM: MaterialOutBOMRow = {
                                        ProductId: PrdId,
                                        ProductCode: PrdCode,
                                        BOMProductId: value.BOMProductId,
                                        BOMAttributeId: BomAtbId,
                                        BomRate: BOMRate,
                                        BomAmount: Amount,
                                        Remarks: value.Remarks,
                                        CalcOn: value.CalculateOn,
                                        Pieces: value.Pieces,
                                        Weight: value.Weight,
                                        ItemTypeId: ItemTypeId,
                                        ItemType: value.ItemType,
                                        KaratId: karat,
                                        MetalColorId: MetalColor,
                                        Purity: BOMPrdDetails.Purity,
                                        Attribute: value.Attribute,
                                        CertificateNo: value.CertificateNo
                                    }
                                    bomdetails.push(MaterialOutBOM);
                                }
                                else if (value.ItemType == "STONE") {

                                    var Shape = BOMPrdATB.ShapeId;
                                    var Size = BOMPrdATB.StoneSizeId;
                                    var ItemTypeId = BOMPrdATB.ItemTypeId;
                                    var Quality = BOMPrdATB.QualityId;
                                    var StoneColor = BOMPrdATB.StoneColorId;

                                    //Get Rate from Pricelist or Standard Rate to Calculate BOM Amount and add it to Item Rate
                                    let BOMRate = GetItemRateHelper.GetPurchaseRate(BomAtbId, rateListId);
                                    var Amount = value.CalculateOn == 3 ? value.Pieces * BOMRate : value.Weight * BOMRate;
                                    Rate += Amount;
                                
                                    var MaterialOutBOM: MaterialOutBOMRow = {
                                        ProductId: PrdId,
                                        ProductCode: PrdCode,
                                        BOMProductId: value.BOMProductId,
                                        BOMAttributeId: BomAtbId,
                                        BomRate: BOMRate,
                                        BomAmount: Amount,
                                        Remarks: value.Remarks,
                                        CalcOn: value.CalculateOn,
                                        Pieces: value.Pieces,
                                        Weight: value.Weight,
                                        ItemType: value.ItemType,
                                        ItemTypeId: ItemTypeId,
                                        ShapeId: Shape,
                                        StoneColorId: StoneColor,
                                        QualityId: Quality,
                                        Attribute: value.Attribute,
                                        CertificateNo: value.CertificateNo
                                    }
                                    bomdetails.push(MaterialOutBOM);
                                }
                            });
                            // #endregion

                            //Calculate Tax Amount
                            //var TAmount = ((Rate + LaborRate) * ItemTax[1]) / 100;
                            if (Stock.StockForMaterialSelectGrid.ItemType == 1) {

                                var MaterialOutitem: MaterialOutItemsRow = {
                                    ProductId: PrdId,
                                    AttributeId: PrdDetails.AttributeId,
                                    VoucherTypeId: value.VoucherTypeId,
                                    Line_No: newLineNo,
                                    PartyId: self.PartyId,
                                    SKU: SKU,
                                    DepartmentId: deptId,
                                    DeptName: OMS.DepartmentMasterRow.getLookup().itemById[value.DepartmentId].DeptName,
                                    ProductCode: value.ProductCode,
                                    ProductName: value.ProductName,
                                    ItemTypeId: value.ItemTypeId,
                                    CategoryId: value.CategoryId,
                                    ProductTypeId: value.ProductTypeId,
                                    ProductTypeName: value.ProductTypeName,
                                    SubCategoryId: value.SubCategoryId,
                                    BrandId: value.BrandId,
                                    SuperTypeId: value.SuperTypeId,
                                    CollectionId: value.CollectionId,
                                    UnitRate: Rate,
                                    UnitLabour: LaborRate,
                                    Pieces: 1,
                                    Weight: value.Weight,
                                    OtherPieces: value.OtherPieces,
                                    OtherWeight: value.OtherWeight,
                                    StonePieces: value.StonePieces,
                                    StoneWeight: value.StoneWeight,
                                    NetWeight: value.NetWeight,
                                    NetAmount: (Rate + LaborRate) * 1,
                                    GrossAmount: (Rate + LaborRate) * 1,
                                    DiamondPieces: value.DiamondPieces,
                                    DiamondWeight: value.DiamondWeight,
                                    CalcOnId: value.CalcOnId,
                                    BOMDetails: bomdetails,
                                    // LaborDetails: labordetail,
                                    CompanyId: companyId,
                                    RefTransId: value.TransId,
                                    HSN: value.HSN,
                                    Purity: value.Purity == undefined ? 0 : value.Purity,
                                    
                                };
                                details.push(MaterialOutitem);
                            }

                            else if (Stock.StockForMaterialSelectGrid.ItemType == 2 || Stock.StockForMaterialSelectGrid.ItemType == 3) {

                                var MaterialOutitem: MaterialOutItemsRow = {
                                    ProductId: PrdId,
                                    AttributeId: PrdDetails.AttributeId,
                                    //Line_No: MaterialEditorForJobWork.Line_No,
                                    VoucherTypeId: value.VoucherTypeId,
                                    PartyId: self.PartyId,
                                    SKU: "0",
                                    DepartmentId: deptId,
                                    DeptName:  value.DeptName,
                                    ProductCode: value.ProductCode,
                                    ProductName: value.ProductName,
                                    ItemTypeId: value.ItemTypeId,
                                    CategoryId: value.CategoryId,
                                    ProductTypeId: value.ProductTypeId,
                                    ProductTypeName: value.ProductTypeName,
                                    SubCategoryId: value.SubCategoryId,
                                    BrandId: value.BrandId,
                                    SuperTypeId: value.SuperTypeId,
                                    CollectionId: value.CollectionId,
                                    UnitRate: Rate,
                                    UnitLabour: LaborRate,
                                    Pieces: value.Pieces,
                                    Weight: value.Weight,
                                    OtherPieces: value.OtherPieces,
                                    OtherWeight: value.OtherWeight,
                                    StonePieces: value.StonePieces,
                                    StoneWeight: value.StoneWeight,
                                    NetWeight: value.NetWeight,
                                    NetAmount: (Rate + LaborRate) * 1,
                                    GrossAmount: (Rate + LaborRate) * 1,
                                    DiamondPieces: value.DiamondPieces,
                                    DiamondWeight: value.DiamondWeight,
                                    CalcOnId: value.CalcOnId,
                                    BOMDetails: bomdetails,
                                    // LaborDetails: labordetail,
                                    CompanyId: companyId,
                                    
                                    HSN: value.HSN,
                                    KaratId: value.KaratId,
                                    MetalColorId: value.MetalColorId,
                                    QualityId: value.QualityId,
                                    SieveId: value.SieveId,
                                    ShapeId: value.ShapeId,
                                    RefTransId: value.TransId,
                                    StoneColorId: value.StoneColorId,
                                    StoneSizeId: value.StoneSizeId,
                                    Purity: value.Purity == undefined ? 0 : value.Purity,
                                    TaxCode:value.TaxCode
                                };
                                details.push(MaterialOutitem);
                            }



                        });

                        if (this.view.getItems().length > 0) {
                            self.TotalItems = details.length + this.view.getItems().length;
                        }
                        else {
                            self.TotalItems = details.length;
                        }
                        for (let Detail of details) {
                            Detail[this.getIdProperty()] = "`" + this.nextId++;
                            var x = Detail;
                            this.view.addItem(Detail);
                        }

                    }
                    // #endregion

                    pickerDialog.dialogOpen();
                }
            });

            buttons.push({
                title: "Select Materials",
                cssClass: "order-button",
                hotkey: "alt+p",
                hint: 'alt+p',
                onClick: () => {
                    var self = this;

                    var bagno = (this.parentMFGItemDialog as Production.JobWorkIssueItemsDialog).form.BagNo.value;
                    if (bagno == "" || bagno == undefined) {
                        q.Alert("View Mode", "Work Order needs to be selected", 2000, false);
                        return;
                    }
                    var grid = Common.WorkOrderStockSelectGrid;
                    var bagno = (self.parentMFGItemDialog as Production.JobWorkIssueItemsDialog).form.BagNo.value;

                    var filters: _Ext.SelectGridFilters = {
                        BagNo: bagno,
                        FilterItems: ItemSelection.S
                    }

                    var pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: grid, multiple: true,
                        preSelectedKeys: this.value.map(k => k.ProductId), GridFilters: filters, Width: 800, height: 500
                    });
                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        var self = this;
                        var details = [];

                        // #region Items to Grid
                        //for (let value of selectedItems2)
                        selectedItems2.forEach(function (value: Stock.StockItemRow) {
                            var PrdId = value.ProductId;
                            var AtbId = value.AttributeId;
                            let newitems;

                            var lineno = parseInt((self.parentMFGItemDialog as Production.JobWorkIssueItemsDialog).form.Line_No.value);

                            var bagno = (self.parentMFGItemDialog as Production.JobWorkIssueItemsDialog).form.BagNo.value;
                            var item: MaterialOutItemsRow = {
                                ProductId: PrdId,
                                DepartmentId: self.DeptId,
                                ProductCode: value.ProductCode,
                                ItemTypeId: value.ItemTypeId,
                                AttributeId: AtbId,
                                Line_No: lineno,
                                SKU: value.SKU,
                                HSN: value.HSN,
                                CertificateNo: value.CertificateNo,
                                BagNo: bagno,
                                CalcOnId: value.CalcOnId,
                                Pieces: value.Pieces,
                                Weight: value.Weight,
                                NetWeight: 0,
                                RefTransId: value.TransId,
                                Purity: value.Purity,
                                PureWeight: value.PureWeight,
                                RefTransItemId: value.TransItemId == null? 0 : value.TransItemId,
                                RefVoucherId: value.VoucherTypeId == null ? 0 : value.VoucherTypeId,
                                Attribute: value.Attribute,
                                KaratId: value.KaratId,
                                MetalColorId: value.MetalColorId,
                                ProductTypeId: value.ProductTypeId,
                                LotNo: value.LotNo,
                                Lab: value.Lab
                            };

                            details.push(item);

                        });

                        for (let Detail of details) {
                            Detail[this.getIdProperty()] = "`" + this.nextId++;
                            this.view.addItem(Detail);
                        }

                        // #endregion


                    }


                    pickerDialog.dialogOpen();
                }
            });
            //var btnAdd = Q.first(buttons, x => x.cssClass == "add-button");

            //btnAdd.onClick = e => { this.addButtonClick(); };
            */
            return buttons;
        }



        // #endregion




        /*
                validateEntity(row, id) {
                    row.P = Q.toId(row.ProductID);
        
                    var sameProduct = Q.tryFirst(this.view.getItems(), x => x.PrdId === row.ProductID);
                    if (sameProduct && this.id(sameProduct) !== id) {
                        Q.alert('This product is already in order details!');
                        return false;
                    }
        
                    return true;
                }*/
    }
}